<template>
  <div>
    <ConversationMessageGroupMediaonlyContainer
      v-for="mediaOnlyGroup in group.groups"
      :group="mediaOnlyGroup as MediaOnlyGroup"
      :current-user
      :key="mediaOnlyGroup.id"
      :is-group-conversation
    />
  </div>
</template>

<script setup lang="ts">
import type {
  GroupType,
  MessageGroupFamily,
  MessageGroupContainer,
} from "~/composables/messages";
import type { UserDisplayData } from "./common";

type MediaOnlyGroup = MessageGroupContainer & { type: GroupType.MEDIAONLY };

defineProps<{
  group: MessageGroupFamily & { type: GroupType.SAMEAUTHOR };
  currentUser: UserDisplayData;
  isGroupConversation: boolean;
}>();
</script>
